import ReactGA from 'react-ga4';

/* ------------------------------------
 * CONSTANTS
 * ------------------------------------ */

// GA Measurement ID
export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

// Event Categories
export const CATEGORY_QUOTE_FLOW = 'Quote Flow';

// Quote Flow Actions
export const ACTION_QUOTE_STARTED = 'quote_started';
export const ACTION_UW_PAGE_1 = 'underwriting_page_1_complete';
export const ACTION_UW_PAGE_2 = 'underwriting_page_2_complete';
export const ACTION_QUOTES_RECEIVED = 'quotes_received';
export const ACTION_QUOTE_SELECTED = 'quote_selected';
export const ACTIION_QUOTE_BOUND = 'quote_bound';
export const ACTION_QUOTE_ABANDONED = 'quote_abandoned';

/* ------------------------------------
 * INITIALIZATION
 * ------------------------------------ */

export const initGA = (): void => {
  ReactGA.initialize(GA_MEASUREMENT_ID, {
    gtagOptions: {
      send_page_view: false // we'll manually track page views
    }
  });
};

/* ------------------------------------
 * PAGE VIEW TRACKING
 * ------------------------------------ */

export const logPageView = (path: string, title?: string): void => {
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    title: title
  });
};

/* ------------------------------------
 * GENERIC EVENT TRACKER
 * ------------------------------------ */

export const logEvent = (
  category: string,
  action: string,
  label: string = '',
  value: number = 0
): void => {
  ReactGA.event({
    category,
    action,
    label,
    value
  });
};

/* ------------------------------------
 * FLOOD QUOTE–SPECIFIC TRACKERS
 * ------------------------------------ */

export const trackQuoteStarted = (address: string = ''): void => {
  logEvent(CATEGORY_QUOTE_FLOW, ACTION_QUOTE_STARTED, address);
};

export const trackUnderwritingPage1Complete = (): void => {
  logEvent(CATEGORY_QUOTE_FLOW, ACTION_UW_PAGE_1);
};

export const trackUnderwritingPage2Complete = (): void => {
  logEvent(CATEGORY_QUOTE_FLOW, ACTION_UW_PAGE_2);
};

export const trackQuotesReceived = (numberOfQuotes: number): void => {
  logEvent(CATEGORY_QUOTE_FLOW, ACTION_QUOTES_RECEIVED, '', numberOfQuotes);
};

export const trackQuoteSelected = (carrier: string): void => {
  logEvent(CATEGORY_QUOTE_FLOW, ACTION_QUOTE_SELECTED, carrier);
};

export const trackQuoteBound = (
  carrier: string,
  premium: number
): void => {
  logEvent(CATEGORY_QUOTE_FLOW, ACTIION_QUOTE_BOUND, carrier, premium);
};

export const trackQuoteAbandoned = (step: string): void => {
  logEvent(CATEGORY_QUOTE_FLOW, ACTION_QUOTE_ABANDONED, step);
};
